module.exports = "/assets/ac3ce846011d32c660d5d46906bdfac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/U9.png
// module id = 1883
// module chunks = 0